import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material';

import {
    MatDialogModule, MatSelectModule, MatSlideToggleModule,
    MatChipsModule, MatAutocompleteModule, MatCheckboxModule
} from '@angular/material';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';
import { AngularSplitModule } from 'angular-split';
import {SetTimeAutoDriftDialogComponent} from './set-time-auto-drift-dialog/set-time-auto-drift-dialog.component'
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { MyFilter2Pipe } from './add-from-list-dialog/myfilter2.pipe';
import { BackupConfigurationsDialogComponent } from './backup-configurations-dialog/backup-configurations-dialog-component'
import { KeepCmsHistoryDialogComponent } from './keep-cms-history-dialog/keep-cms-history-dialog.component';
import { AddExceptionDialogComponent } from './add-exception-dialog/add-exception-dialog.component';
import { AddFromListDialogComponent } from './add-from-list-dialog/add-from-list-dialog.component';
import { AddOneFromListDialogComponent } from './add-one-from-list-dialog/add-one-from-list-dialog.component';
import { AddTagDialogComponent } from './add-tag-dialog/add-tag-dialog.component';
import { SuccessDialogComponent } from './success-dialog/success-dialog.component';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { MultiUpgradePreValidatePackageDialogComponent } from './multi-upgrade-prevalidate-package-dialog/multi-upgrade-prevalidate-package-dialog.component';
import { MultiRollbackPackageDialogComponent } from './multi-rollback-package-dialog/multi-rollback-package-dialog.component';
import { AddOrEditActivityComponent } from './add-or-edit-activity-dialog/add-or-edit-activity-dialog.component';
import { PackagePromotionDialogComponent } from './package-promotion-dialog/package-promotion-dialog.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { RegexpCheckerDialogComponent } from './regexp-checker-dialog/regexp-checker-dialog.component';
import { ScriptViewerDialogComponent } from './script-viewer-dialog/script-viewer-dialog.component';
import { TimeoutDialogComponent } from './timeout-dialog/timeout-dialog.component';
import { ContainerDialogComponent } from './container-dialog/container-dialog.component';
import { DynamicComponentModule } from '../dynamic-component/dynamic-component.module';
import { CategoryDialogComponent } from '@app/shared/components/dialogs/add-category-dialog/category-dialog.component';
import { RestoreBackupDialogComponent } from '@app/shared/components/dialogs/restore-backup-dialog/restore-backup-dialog.component';
import { BackupDialogComponent } from '@app/shared/components/dialogs/backup-dialog/backup-dialog.component';
import { ValidateDialogComponent } from '@app/shared/components/dialogs/validate-dialog/validate-dialog.component';
import { SetTypeDialogComponent } from '@app/shared/components/dialogs/set-type-dialog/set-type-dialog.component';
import { BuildDialogComponent } from '@app/shared/components/dialogs/build-dialog/build-dialog.component';
import { ManageEnvironmentTypesDialogComponent } from '@app/shared/components/dialogs/manage-environment-types-dialog/manage-environment-types-dialog.component';
import { BuildByTaskDialogComponent } from '@app/shared/components/dialogs/build-by-task-dialog/build-by-task-dialog.component';
import { MatInputModule } from '@angular/material/input';
import { RunPackageDialogComponent } from '@app/shared/components/dialogs/run-package-dialog/run-package-dialog.component';
import {UpdateDevEnvDialogComponent} from "@app/shared/components/dialogs/update-devenv-dialog/update-devenv-dialog.component";
import { ViewLabelDialogComponent } from '@app/shared/components/dialogs/view-label-dialog/view-label-dialog.component';
import { ApplyLabelDialogComponent } from '@app/shared/components/dialogs/apply-label-dialog/apply-label-dialog.component';
import {UploadScriptDialogComponent} from '@app/shared/components/dialogs/upload-script-dialog/upload-script-dialog.component';
import {RollbackToVersionDialogComponent} from '@app/shared/components/dialogs/rollback-to-version-dialog/rollback-to-version-dialog.component'
import { FirstDeploymentNoteDialogComponent } from '@app/shared/components/dialogs/first-deployment-note-dialog/first-deployment-note-dialog.component';
import { UpgradePreValidateToVersionDialogComponent } from '@app/shared/components/dialogs/upgrade-prevalidate-to-version-dialog/upgrade-prevalidate-to-version-dialog.component';
import { ClusterDialogComponent } from '@app/shared/components/dialogs/cluster-dialog/cluster-dialog.component';
import {SetVersionDialogComponent} from "@app/shared/components/dialogs/set-version-dialog/set-version-dialog.component";
import {MessageDialogComponent} from "@app/shared/components/dialogs/message-dialog/message-dialog.component";
import {AffectedDialogComponent} from "@app/shared/components/dialogs/affected-tag-dialog/affected-tag-dialog.component";
import {TagObjectDialogComponent } from "@app/shared/components/dialogs/tag-objects-dialog/tag-objects-dialog.component";
import {ImpactAnalysisDiffDialogComponent} from "@app/shared/components/dialogs/impact-analysis-diff-dialog/impact-analysis-diff-dialog.component";
import { MatTableModule } from '@angular/material/table';
import { AddPackageDialogComponent } from "@app/shared/components/dialogs/add-package-dialog/add-package-dialog.component";
import { EnvSettingDialog } from './environment-setting-dialog/environment-setting-dialog.component'; 
import { DbmFileUploadModule } from '@app/shared/components/dbm-components/dbm-file-upload/dbm-file-upload.module';
import { DbmAutocompleteComponent } from './dbm-autocomplete/dbm-autocomplete.component';


const dialogs = [

    CategoryDialogComponent,
    AddExceptionDialogComponent,
    TagObjectDialogComponent,
    EnvSettingDialog,
    AddPackageDialogComponent,
    AddOrEditActivityComponent,
    AddFromListDialogComponent,
    AddOneFromListDialogComponent,
    ImpactAnalysisDiffDialogComponent,
    AddTagDialogComponent,
    UpdateDevEnvDialogComponent,
    SetTimeAutoDriftDialogComponent,
    MessageDialogComponent,
    AffectedDialogComponent,
    SuccessDialogComponent,
    BackupConfigurationsDialogComponent,
    KeepCmsHistoryDialogComponent,
    ErrorDialogComponent,
    SetVersionDialogComponent,
    MultiUpgradePreValidatePackageDialogComponent,
    MultiRollbackPackageDialogComponent,
    PackagePromotionDialogComponent,
    ConfirmationDialogComponent,
    RegexpCheckerDialogComponent,
    ScriptViewerDialogComponent,
    TimeoutDialogComponent,
    ContainerDialogComponent,
    RestoreBackupDialogComponent,
    UploadScriptDialogComponent,
    BackupDialogComponent,
    ValidateDialogComponent,
    RollbackToVersionDialogComponent,
    SetTypeDialogComponent,
    BuildDialogComponent,
    ManageEnvironmentTypesDialogComponent,
    BuildByTaskDialogComponent,
    RunPackageDialogComponent,
    ViewLabelDialogComponent,
    ApplyLabelDialogComponent,
    FirstDeploymentNoteDialogComponent,
    UpgradePreValidateToVersionDialogComponent,
    ClusterDialogComponent,
    DbmAutocompleteComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatSelectModule,
        DbmFileUploadModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        ScrollDispatchModule,
        AngularSplitModule,
        MatTableModule,
        DirectivesModule,
        PipesModule,
        DynamicComponentModule,
        MatInputModule,
        ReactiveFormsModule
    ],
    declarations: [...dialogs, MyFilter2Pipe],
    providers: [MyFilter2Pipe, { provide: MAT_DIALOG_DATA, useValue: {} }],
    entryComponents: [...dialogs],
    exports: [...dialogs]
})
export class DialogsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/dialogs.module.ts